import type { CompletePage, Media } from "@pdfking/renderer-api"

// Media derived synchronously from the completed page recipe — no file bytes
// needed: the page's size is the trim, its bleed round it each side by its own.
export const PlotBoxes = ({ width, height, bleed }: CompletePage): Media => ({
  trim: { width, height },
  bleed,
})
